<div class="padding">
  <h3> {{'toolbar.settings.patch' | translate }} </h3>

  @for (patch of patchNotes; track patch; let i = $index) {
    <!--<H3>{{patch.versionnumber}}</H3>-->
    <div style="padding: 10px;" [innerHTML]="patch.text"></div>
  }
</div>